import { OrderExtraStatus, OrderStatus } from '@/resources/enums'
import { ORDERS_HISTORY_PAGE as dict } from '@/resources/dict'

export const orderStatusLabel = {
  [OrderStatus.DELIVERED]: dict.orderStatus.delivered,
  [OrderStatus.POC_ACCEPTED]: dict.orderStatus.accepted,
  [OrderStatus.USER_CANCELLED]: dict.orderStatus.userCancelled,
  [OrderStatus.POC_REJECT]: dict.orderStatus.rejected,
  [OrderStatus.POC_PICKED_UP]: dict.orderStatus.pocPickedUp,
  [OrderStatus.SUSPECT]: dict.orderStatus.suspect,
  [OrderStatus.DM_ACCEPTED]: dict.orderStatus.dmAccepted,
  [OrderStatus.DM_PICKED_UP]: dict.orderStatus.dmPickedUp,
  [OrderStatus.DM_EN_ROUTE]: dict.orderStatus.enRoute,
  [OrderStatus.DM_CANCELLATION_REQUEST]: dict.orderStatus.cancellationRequest,
  [OrderStatus.POC_ABANDONED]: dict.orderStatus.abandoned,
  [OrderStatus.POC_EXPIRED]: dict.orderStatus.expired,
  [OrderStatus.PENDING]: dict.orderStatus.pending,
  [OrderStatus.TRANSFERED]: dict.orderStatus.transferred,
  [OrderStatus.POC_SCHEDULED]: dict.orderStatus.pocScheduled,
  [OrderStatus.CS_CANCELLEDOC]: dict.orderStatus.csCancelledDoc,
  [OrderStatus.DM_REJECT]: dict.orderStatus.rejected,
  [OrderStatus.DM_EXPIRED]: dict.orderStatus.dmExpired,
  [OrderExtraStatus.WAITING_COURIER]: dict.orderStatus.waitingCourier,
  [OrderExtraStatus.WAITING_CONSUMER]: dict.orderStatus.waitingConsumer,
}

export const orderStatusFilterLabel = {
  [OrderStatus.POC_ACCEPTED]: dict.orderStatus.accepted,
  [OrderStatus.DM_EN_ROUTE]: dict.orderStatus.enRoute,
  [OrderStatus.DELIVERED]: dict.orderStatus.delivered,
  [OrderStatus.POC_ABANDONED]: dict.orderStatus.abandoned,
  [OrderStatus.USER_CANCELLED]: dict.orderStatus.userCancelled,
  [OrderStatus.DM_CANCELLATION_REQUEST]: dict.orderStatus.cancellationRequest,
  [OrderStatus.DM_PICKED_UP]: dict.orderStatus.pickedUp,
  [OrderStatus.POC_REJECT]: dict.orderStatus.rejected,
  [OrderStatus.POC_EXPIRED]: dict.orderStatus.expired,
  [OrderStatus.SUSPECT]: dict.orderStatus.suspect,
}
